export default {
  AUTHORIZE: 'AUTHORIZED',
  CAPTURE: 'CAPTURED',
  VOID: 'VOIDED',
  REFUND: 'REFUNDED',
  FAILED: 'FAILED',
};
